import { ColorPickerInputGroup, tailwindColors } from "twyne-new.ui"

const ColorPreview = ({ value, ...props }) => {
  const colorRendered = !value ? undefined : typeof value === 'string' ? { hex: tailwindColors[value], name: value } : value
  return <ColorPickerInputGroup {...props} value={colorRendered} />
}

export default ColorPreview
